import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  EventEmitter,
  Output
} from '@angular/core';
import { Survey } from '../../../../classes';
import { Subscription } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { FormGroup, FormControl } from '@angular/forms';
import { DateToTimePipe } from '../../../shared';
import { ReplyService } from '../../../../services';

@Component({
  selector: 'reply-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DateToTimePipe]
})
export class HeaderComponent implements OnInit {
  @Input() survey: Survey;
  @Input() replyFormGroup: FormGroup;
  @Output() onSubmit = new EventEmitter();
  subscriptions: Subscription[] = [];

  constructor(public reply: ReplyService, private cdRef: ChangeDetectorRef) {}
  open_at: FormControl;
  close_at: FormControl;

  removeControllers() {
    this.replyFormGroup.removeControl('openAtControl');
    this.replyFormGroup.removeControl('closeAtControl');
  }
  ngOnInit() {
    this.subscriptions.push(
      this.replyFormGroup.statusChanges.subscribe(() =>
        this.cdRef.detectChanges()
      )
    );
    this.subscriptions.push(
      this.reply.tracker.onContentUpdate
        .pipe(
          map(() => this.reply.isChanged),
          distinctUntilChanged()
        )
        .subscribe(() => this.cdRef.detectChanges())
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.removeControllers();
  }
  refreshView() {
    this.open_at.updateValueAndValidity();
    this.close_at.updateValueAndValidity();
    this.cdRef.detectChanges();
  }
  submit() {
    this.onSubmit.next(null);
  }
}
